<template>
    <TransitionFade>
        <Shell v-if="isStatusAcceptable">

            <Navigation />

            <Main>
                <router-view />
            </Main>

            <FloatNavigation />
            <FloatScrolling />

            <Overlay />
            <Dialogs :injected="dialogs" />
            <Windows :injected="windows" />
            <Notifications />
        </Shell>
    </TransitionFade>

    <Status @status="handleStatus" />
</template>

<script>
import API from '@generio-ai/library-legacy/constants/api'
import Shell from '@generio-ai/library-legacy/components/shell'
import Navigation from '@generio-ai/library-legacy/components/navigation'
import Main from '@generio-ai/library-legacy/components/main'
import { FloatNavigation, FloatScrolling } from '@generio-ai/library-legacy/components/floats'
import Overlay from '@generio-ai/library-legacy/components/overlay'
import Dialogs from '@generio-ai/library-legacy/components/dialogs'
import Notifications from '@generio-ai/library-legacy/components/notifications'
import Status from '@generio-ai/library-legacy/components/status'
import { TransitionFade } from '@generio-ai/library-legacy/components/transitions'
import DialogCamera from '@/components/common/dialog/DialogCamera.vue'
import DialogHistory from '@/components/common/dialog/DialogHistory.vue'
import DialogProjection from '@/components/common/dialog/DialogProjection.vue'
import DialogRating from '@/components/common/dialog/DialogRating.vue'
import DialogRestart from '@/components/common/dialog/DialogRestart.vue'
import DialogSettings from '@/components/common/dialog/DialogSettings.vue'
import DialogShare from '@/components/common/dialog/DialogShare.vue'
import DialogWelcome from '@/components/common/dialog/DialogWelcome.vue'
import Windows from '@/components/common/windows/Windows.vue'
import WindowAsset from '@/components/common/windows/WindowAsset.vue'
import WindowLibrary from '@/components/common/windows/WindowLibrary.vue'

export default {
    name: 'Webclient',
    components: {
        Shell,
        Navigation,
        Main,
		FloatNavigation,
		FloatScrolling,
        Overlay,
        Dialogs,
        Windows,
        Status,
        Notifications,
        TransitionFade
    },
    data() {
        return {
            status: null
        }
    },
    computed: {
        isStatusAcceptable() {
            return this.status === API.STATUS.UNRESPONSIVE ||
                   this.status === API.STATUS.OPERATIONAL || 
                   this.status === API.STATUS.DEGRADED
        },

        dialogs() {
            return {
                'camera': DialogCamera,
                'history': DialogHistory,
                'projection': DialogProjection,
                'rating': DialogRating,
                'restart': DialogRestart,
                'settings': DialogSettings,
                'share': DialogShare,
                'welcome': DialogWelcome
            }
        },

        windows() {
            return {
                "asset": WindowAsset,
                "library": WindowLibrary,
            }
        }
    },
    methods: {
        handleStatus(status) {
            this.status = status
        }
    }
}
</script>